import { NgModule } from '@angular/core';
import { mapToCanActivate, RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from '@app/components/home-page/home-page.component';
import { HomePageGuard } from '@app/components/home-page/home-page.guard';
import { MainContentComponent } from '@app/components/main-content/main-content.component';
import { InvoicesComponent } from '@app/components/invoice/invoices.component';
import { AlertLogComponent } from '@app/components/alert-log/alert-log.component';
import { SettingsComponent } from '../components/settings/settings.component';
import { EditedInvoiceComponent } from '../components/edited-invoice/edited-invoice.component';
import { SamlCallbackComponent } from '../components/saml-callback/saml-callback.component';
import { ContractsComponent } from '@app/components/contracts/contracts.component';
import { AuthGuard } from '@app/shared/auth/auth.guard';
import { SsoSignInComponent } from '@app/components/sso-sign-in/sso-sign-in.component';
import { SsoSignInHeaderComponent } from '@app/components/sso-sign-in-header/sso-sign-in-header.component';

const routes: Routes = [
  {
    path: '',
    canActivate: mapToCanActivate([AuthGuard]),
    component: SsoSignInComponent,
  },
  {
    path: 'login',
    component: SsoSignInHeaderComponent,
  },
  {
    path: 'saml-callback',
    component: SamlCallbackComponent,
  },
  {
    path: 'home',
    canActivate: mapToCanActivate([HomePageGuard]),
    canActivateChild: mapToCanActivate([HomePageGuard]),
    component: HomePageComponent,
    children: [
      { path: '', component: MainContentComponent },
      { path: 'contracts', component: ContractsComponent },
      { path: 'invoices', component: InvoicesComponent },
      { path: 'alerts', component: AlertLogComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'import', component: EditedInvoiceComponent },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
